import { createAsyncThunk } from '@reduxjs/toolkit';
import { MateriService } from 'Services/axios/Materi.Service';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchMaterial = createAsyncThunk(
  'Materi/fetchMateri',
  async (filters) => {
    try {
      const response = await MateriService.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitMaterial = createAsyncThunk(
  'addMateri/submitMateri',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('name', data.name);
      const descriptionContent = data.description;
      const cleanedContent = descriptionContent.replace(/<[^>]*>/g, '').trim();
      if (cleanedContent.length > 0) {
        formData.append('description', data.description);
      }
      data.image && formData.append('image', data.image);
      // Handle subMaterials as array 
      if (data.subMaterials && data.subMaterials.length > 0) {
        data.subMaterials.forEach((subMaterial, index) => {
          formData.append(`subMaterials[${index}][id]`, subMaterial.id);
        });
      }
      let response;
      if (data.isUpdate) {
        response = await MateriService.update(data.id, formData);
      } else {
        response = await MateriService.create(formData);
      }
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteMaterial = createAsyncThunk(
  'deleteMateri/deleteMateri',
  async (id) => {
    try {
      const response = await MateriService.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);


